import styles from './AttachmentsList.module.scss';
import React, { useCallback, useMemo } from 'react';
import Thumbnail from '../Thumbnail/Thumbnail';

/**
 * Renders a row of attachment thumbnails. Falsy attachments are skipped and nothing is rendered when none remain.
 *
 * @param {Object} props
 * @param {Array<Object|File>} props.attachments - Attachments to display.
 * @param {string} [props.className] - Extra class name for the container.
 * @param {Object} [props.style] - Extra inline styles for the container.
 * @param {boolean} [props.hscroll] - Scroll horizontally on overflow instead of hiding it.
 * @param {number|string} [props.size] - Thumbnail size passed to each Thumbnail.
 * @param {function(Object|File): void} [props.onImageClicked] - Called with the attachment when a thumbnail is clicked.
 * @returns {React.ReactElement|null}
 */
export default function AttachmentsList(props) {
    const { attachments, className, style, hscroll, size, onImageClicked } = props,
        validAttachments = useMemo(() => attachments.filter(Boolean), [attachments]);

    const handleImageClicked = useCallback(
        (attachment) => {
            if (attachment && onImageClicked) {
                onImageClicked(attachment);
            }
        },
        [onImageClicked]
    );

    if (!validAttachments.length) {
        return null;
    }

    return (
        <div className={[styles.AttachmentsList, hscroll ? styles.horizontalScroll : '', className].join(' ')} style={style}>
            {validAttachments.map((attachment, i) => (
                <Thumbnail className={styles.attachment} file={attachment} key={i} size={size} onClick={onImageClicked ? handleImageClicked : null} />
            ))}
        </div>
    );
}
